import * as React from "react";
import { RowTitleButton } from "common/components";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import StepActionsButton from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
const TitleCell = ({ step }) => {
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => toggleSection(step.id, "restFieldsExpandedSection");
  return /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: toggleExtraSection }, (step == null ? void 0 : step.title) || "No title set");
};
export const columnRenderers = {
  attributes: {
    title: {
      renderCell: (_, step) => /* @__PURE__ */ React.createElement(TitleCell, { step })
    },
    type: {
      renderCell: (_, step) => /* @__PURE__ */ React.createElement(StepActionsButton, { step }),
      staticWidth: 140
    }
  }
};
